import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Grid } from '@mui/material';
import { useEffect } from 'react';
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from '../../components/Form/Fields/AdaptacionesCurriculares';
import Caracterizacion from '../../components/Form/Fields/Caracterizacion';
import CondicionesContexto from '../../components/Form/Fields/CondicionesContexto';
import ConsideracionesAdicionales from '../../components/Form/Fields/ConsideracionesAdicionales';
import TemaClase from '../../components/Form/Fields/TemaClase';
import GetObjetivosAprendizaje from '../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje';
import PreguntasPensamientoCriticoCardImg from '../../components/UmmIApps/Cards/PreguntasPensamientoCriticoCardImg.png';
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const PreguntasPensamientoCriticoPage = () => {

    const {
        materiaId,
        nivelId,
        handleBack,
        promptData,
        toggleCamposAvanzados,
        mostrarCamposAvanzados,
        isOAAdded,
        handleInitialPromptData,
        handleNivelChange,
        handleAsignaturaChangeLocal
    } = useActividadesContext();


    //Variable para condicionar la habilitación del botón "Generar"
    const isButtonDisabled = !(promptData.nivel && promptData.materia && promptData.tema && isOAAdded);
    const colorIconBack = '#BA4534'

    useEffect(() => {
        const init = {
            nivel: '',
            objetivos: [],
            materia: '',
            tema: '',
            consideraciones: '',
            caracterizacion: '',
            condiciones_contexto: '',
            adaptaciones_curriculares: '',
        }
        handleInitialPromptData(init, "preguntas_pensamiento_critico");
    }, []);

    return (
        <>
            <UmmiaAppsLayout
                onBack={handleBack}
                imageSrc={PreguntasPensamientoCriticoCardImg}
                backgroundColorImage={'linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)'}
                titleColor="#BA4534"
                title="Preguntas de Pensamiento Crítico"
                description="Diseña preguntas que despierten la curiosidad, invitando a los estudiantes a examinar la información de manera rigurosa, cuestionar supuestos y desarrollar un pensamiento independiente y fundamentado."
                isButtonDisabled={isButtonDisabled}
                colorIconBack={colorIconBack}
            >
                <Grid item xs={12} lg={12} display="flex" flexDirection="row">
                    <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
                        <GetNiveles
                            onNivelChange={handleNivelChange}
                            selectedNivel={nivelId}
                        />
                    </Grid>

                    {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
                    <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
                        <GetAsignaturas
                            nivelId={nivelId}
                            onAsignaturaChange={handleAsignaturaChangeLocal}
                            selectedAsignatura={materiaId}
                        />
                    </Grid>
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <GetObjetivosAprendizaje
                        nombreAsignatura={promptData.materia}
                        nombreNivel={promptData.nivel}
                    />
                </Grid>

                <Grid item xs={12} lg={12} md={12} display={'flex'} flexDirection={'row'}>
                    <TemaClase />
                </Grid>

                <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
                    <Button
                        variant="text"
                        sx={{ color: '#336B87' }}
                        onClick={toggleCamposAvanzados}
                        endIcon={mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />}
                    >
                        {mostrarCamposAvanzados ? 'Ocultar opciones avanzadas' : 'Mostrar opciones avanzadas (opcional)'}
                    </Button>
                </Grid>

                {/* Campos avanzados */}
                {mostrarCamposAvanzados && (
                    <>
                        <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                            <ConsideracionesAdicionales />
                        </Grid>

                        <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                            <CondicionesContexto />
                        </Grid>

                        <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                            <Caracterizacion />
                        </Grid>

                        <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                            <AdaptacionesCurriculares />
                        </Grid>
                    </>
                )}
            </UmmiaAppsLayout>
        </>
    );
};

export default PreguntasPensamientoCriticoPage;
